import { render, staticRenderFns } from "./AgGridWrapper.vue?vue&type=template&id=780ae256&"
import script from "./AgGridWrapper.vue?vue&type=script&lang=js&"
export * from "./AgGridWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports